import React from 'react';

const channels = [
  { name: 'Phone (PSTN)', icon: 'fa-phone', iconType: 'fa' },
  { name: 'SMS', icon: 'fa-comment-sms', iconType: 'fa' },
  { name: 'WhatsApp', img: '/assets/integrations/whatsapp.svg' },
  { name: 'Email', icon: 'fa-envelope', iconType: 'fa' },
  { name: 'Discord', img: '/assets/integrations/discord.svg', comingSoon: true },
  { name: 'Telegram', img: '/assets/integrations/telegram.svg', comingSoon: true },
];

const providers = [
  { name: 'Twilio', subtitle: 'Telephony', img: '/assets/integrations/twilio.svg' },
  { name: 'Telnyx', subtitle: 'Telephony', img: '/assets/integrations/telnyx.png', imgClass: 'h-6 w-auto' },
  { name: 'Deepgram', subtitle: 'Speech-to-Text', img: '/assets/integrations/deepgram.svg' },
  { name: 'OpenAI', subtitle: 'LLM + TTS', img: '/assets/integrations/openai.svg' },
  { name: 'Google Cloud', subtitle: 'TTS', img: '/assets/integrations/google-cloud.svg' },
  { name: 'GroqCloud', subtitle: 'LLM', img: '/assets/integrations/groq.svg' },
];

const integrations = [
  { name: 'Google Calendar', subtitle: 'Scheduling', img: '/assets/integrations/google-calendar.svg' },
  { name: 'Google Sheets', subtitle: 'Customer Data', img: '/assets/integrations/google-sheets.svg' },
  { name: 'Webhooks', subtitle: 'Real-time Events', icon: 'fa-bolt', iconType: 'fa' },
  { name: 'MCP', subtitle: 'Custom APIs', icon: 'fa-plug', iconType: 'fa' },
  { name: 'Stripe', subtitle: 'Payments', img: '/assets/integrations/stripe.svg' },
  { name: 'More Coming', subtitle: 'Build with us', icon: 'fa-plus', iconType: 'fa', comingSoon: true },
];

const IconCard = ({ item }) => {
  const isBrand = item.iconType === 'brand';

  return (
    <div className="relative group flex flex-col items-center gap-3 p-5 rounded-xl bg-gradient-to-br from-neutral-700/50 to-neutral-800 hover:from-neutral-600/50 hover:to-neutral-700 transition-all border border-neutral-700/50 hover:border-neutral-600 w-[calc(50%-8px)] sm:w-[calc(33.333%-11px)] md:w-[140px]">
      {item.comingSoon && (
        <span className="absolute -top-2 -right-2 bg-[#055EFD] text-white text-[10px] font-bold font-['Inter'] px-2 py-0.5 rounded-full uppercase tracking-wider">
          Soon
        </span>
      )}
      <div className="w-14 h-14 rounded-xl bg-neutral-900/60 flex items-center justify-center p-2">
        {item.img ? (
          <img
            src={item.img}
            alt={item.name}
            className={item.imgClass || 'w-8 h-8'}
          />
        ) : (
          <i
            className={`${isBrand ? 'fa-brands' : 'fa-solid'} ${item.icon} text-2xl`}
            style={{ color: item.color || '#0AF1FE' }}
          />
        )}
      </div>
      <div className="text-center">
        <p className="!text-white text-sm font-semibold font-['Inter']">{item.name}</p>
        {item.subtitle && (
          <p className="!text-stone-400 text-xs font-medium font-['Inter'] mt-0.5">{item.subtitle}</p>
        )}
      </div>
    </div>
  );
};

const SectionRow = ({ label, items }) => (
  <div className="mb-10 last:mb-0">
    <p className="!text-stone-400 text-xs font-bold font-['Inter'] uppercase tracking-widest mb-4 text-center">
      {label}
    </p>
    <div className="flex flex-wrap justify-center gap-4">
      {items.map((item) => (
        <IconCard key={item.name} item={item} />
      ))}
    </div>
  </div>
);

const Integrations = () => {
  return (
    <div id="integrations" className="px-8 py-20 bg-neutral-900">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-14">
          <h2 className="!text-white text-3xl lg:text-4xl font-bold font-['Montserrat'] mb-4">
            Connect Your Channels & Tools
          </h2>
          <p className="!text-stone-300 text-lg font-medium font-['Inter'] max-w-3xl mx-auto">
            Your assistant works across every channel your customers use, powered by best-in-class providers, and connected to the tools you already rely on.
          </p>
        </div>

        <SectionRow label="Communication Channels" items={channels} />
        <SectionRow label="Telephony & AI Providers" items={providers} />
        <SectionRow label="Business Integrations" items={integrations} />

        <div className="mt-10 text-center">
          <p className="!text-stone-400 text-sm font-medium font-['Inter']">
            Bring your own API keys for any provider, or use ours. <span className="!text-[#0AF1FE]">Your choice.</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Integrations;
